import { Service } from "../../types/Service";
import useProductWithThumbnails from "./useProductsWithThumbnails";
import {
  EvaporatorProductCapacities,
  EvaporatorProductCapacity,
} from "../../types/EvaporatorProductCapacity";
import useSingleEvaporatorSearch from "./useSingleEvaporatorSearch";

const useSingleEvaporatorService = (): {
  evaporatorService: Service<EvaporatorProductCapacities>;
} => {
  const { evaporatorService } = useSingleEvaporatorSearch();

  const { productsWithThumbnails: evaporatorsWithThumbnailsService } =
    useProductWithThumbnails<EvaporatorProductCapacity>(evaporatorService);

  return {
    evaporatorService: evaporatorsWithThumbnailsService,
  };
};

export default useSingleEvaporatorService;
